import { intercomUpdate } from '@/utils/intercom';

export const state = () => ({
  locales: ['en'],
  locale: 'en',
  user: null,
});

export const getters = {
  user: (state) => state.user,
  isLoggedIn: (state) => state.user !== null,
};

export const mutations = {
  SET_LANG(state, locale) {
    if (state.locales.includes(locale)) {
      state.locale = locale;
    }
  },

  setUser(state, user) {
    state.user = user;
  },
};

export const actions = {
  async getUser({ commit }) {
    const { data } = await this.$axios.get(
      `${this.$config.apiBaseUrl}/user/me`,
      { withCredentials: true },
    );

    commit('setUser', data);
    intercomUpdate();

    return data;
  },
};
